export default __webpack_public_path__ + "static/media/stickerw.adb3c6ef.png";